import React, {useContext, useEffect, useState} from 'react';

import {DispatchModeSelectionModal} from "./DispatchModeSelectionModal";
import {CubbyAssignedSuccessModal} from "./CubbyAssignedSuccessModal";
import {CubbyNameInputModal} from "./CubbyNameInputModal";
import {CubbyConflictDetectedModal} from "./CubbyConflictDetectedModal";
import {CubbyAssignmentFailedModal} from "./CubbyAssignmentFailedModal"
import {assignCubby} from "../../../services/CubbyService";
import {AppContext} from "../../../contexts/AppContext";

export function CubbyModalController() {
    const [isCubbyDispatchSelectionOpen, setIsCubbyDispatchSelectionOpen] = useState(false);
    const [isCubbyInputOpen, setIsCubbyInputOpen] = useState(false);
    const [isAssignSuccessOpen, setIsAssignSuccessOpen] = useState(false);
    const [isAssignConflictOpen, setIsAssignConflictOpen] = useState(false);
    const [isAssignFailedOpen, setIsAssignFailedOpen] = useState(false);
    const [cubbyDisplayText, setCubbyDisplayText] = useState(null);
    const [order, setOrder] = useState(null);

    const {backupAreaId, cubbyProcessOrder, setCubbyProcessOrder, setCubbyProcessSuccessOrder} = useContext(AppContext);

    useEffect(() => {
        setOrder(cubbyProcessOrder);
        if (cubbyProcessOrder === null) {
            resetAllModal(false);
            return;
        }
        Boolean(backupAreaId) ? setIsCubbyDispatchSelectionOpen(true) : setIsCubbyInputOpen(true)
    }, [cubbyProcessOrder]);

    const assignToCubby = (cubbyIdToAssign, isPickupArea) => {
        const cubbyPayload = {
            orderInfo: {
                "orderInternalId": order.id,
                "orderExternalId": order.externalId,
                "partnerId": order.brandInfo?.partnerId,
                "locationId": order.locationId,
                "restaurantId": order.brandInfo?.id,
                "orderStatus": 'ORDER_ACCEPTED',
                "sourceDisplayName": order.sourceInfo?.name,
                "menuDetails": null,
                "assignedTimestamp": null
            },
            cubbyDisplayId: cubbyIdToAssign
        };
        assignCubby(cubbyPayload).then(() => {
            setCubbyDisplayText(`${isPickupArea ? "" : "cubby "}${cubbyIdToAssign}`);
            resetAllModal(false);
            setIsAssignSuccessOpen(true);
        }).catch((error) => {
            resetAllModal(false);
            if (error.responseError === "CUBBY_ALREADY_ASSIGNED") {
                setIsAssignConflictOpen(true);
            } else {
                setIsAssignFailedOpen(true);
            }
        });
    };


    const resetAllModal = (isResetCubby = true) => {
        setIsCubbyDispatchSelectionOpen(false);
        setIsCubbyInputOpen(false);
        setIsAssignSuccessOpen(false);
        setIsAssignConflictOpen(false);
        setIsAssignFailedOpen(false);
        if (isResetCubby) {
            setCubbyProcessOrder(null);
        }
    };

    return (
        <>
            <DispatchModeSelectionModal isOpen={isCubbyDispatchSelectionOpen}
                                        onCubbyInput={() => {
                                            setIsCubbyInputOpen(true)
                                        }}
                                        onPickUpCounterAssign={() => assignToCubby(backupAreaId, true)}
                                        onClose={resetAllModal}/>

            <CubbyNameInputModal isOpen={isCubbyInputOpen} order={order}
                                 onCubbyAssign={(id) => assignToCubby(id, false)}
                                 onCancel={resetAllModal}
                                 onClose={resetAllModal}/>

            <CubbyAssignedSuccessModal isOpen={isAssignSuccessOpen} onClose={() => {
                resetAllModal();
                setCubbyProcessSuccessOrder(order);
            }} cubbyId={cubbyDisplayText}
                                       orderId={order?.externalId}/>
            <CubbyConflictDetectedModal isOpen={isAssignConflictOpen}
                                        onChooseAnotherCubby={() => {
                                            resetAllModal(false);
                                            setIsCubbyInputOpen(true);
                                        }}
                                        onClose={resetAllModal}/>
            <CubbyAssignmentFailedModal isOpen={isAssignFailedOpen} onClose={resetAllModal}/>
        </>
    );
}